import Image from "next/image";
import React from "react";
import OpportunityPie from "../../public/images/invest/opportunity-pie-graph.svg";

const BigOpportunity = () => {
  return (
    <div className="bg-full-bleed-green">
      <div className="py-40 text-center">
        <div className="text-lg font-bold">No shortage of opportunity</div>
        <div className="text-5xl font-extrabold mt-14">
          A Big Market to Go After
        </div>
        <div className="mt-10 font-semibold leading-loose">
          Potential Easy Duct App Market is 500,000 active users per year,
          <br /> with sales ramping at a rate of 5,000 active users in
          2023-2024.
        </div>
        <div className="flex justify-center mt-20 w-full h-[539px]">
          <Image
            src={OpportunityPie.src}
            width={800}
            height={539}
            alt=""
            layout="fixed"
          />
        </div>
        <div className="mt-32 text-[#8E8E8E] text-center">
          {
            "* This data was sourced from https://www.zippia.com/advice/digital-transformation-statistics"
          }
        </div>
      </div>
    </div>
  );
};

export default BigOpportunity;
